import { render, staticRenderFns } from "./StockviewStock.vue?vue&type=template&id=49e09246&scoped=true&"
import script from "./StockviewStock.vue?vue&type=script&lang=js&"
export * from "./StockviewStock.vue?vue&type=script&lang=js&"
import style0 from "./StockviewStock.vue?vue&type=style&index=0&id=49e09246&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e09246",
  null
  
)

export default component.exports